{
  "intro": "การรับเข้า (受入) และจ่ายออก (払出) ของมือสองทั้งหมด: รับซื้อ ฝากขาย คืนของ เก็บอย่างน้อย 3 ปี",
  "readonly": "古物台帳 แก้หรือลบไม่ได้ (古物営業法) ถ้าผิดให้เพิ่มแถว 訂正 แทน",
  "not_checked": "รูปแบบ 様式15 / 様式16 ยังไม่ได้ให้ 行政書士 ตรวจ",
  "tabs": {
    "label": "แสดง",
    "all": "ทุกแถว",
    "incomplete": "ข้อมูลไม่ครบ"
  },
  "columns": {
    "date": "วันที่",
    "type": "รับเข้า / จ่ายออก",
    "item": "รายการและจุดสังเกต",
    "quantity": "จำนวน",
    "price": "ราคา",
    "counterparty": "คู่ค้า",
    "address": "ที่อยู่",
    "occupation": "อาชีพ",
    "age": "อายุ",
    "minor": "ต่ำกว่า 18",
    "method": "ตรวจบัตรด้วย",
    "no_method": "ไม่มี 本人確認",
    "channel": "วิธี",
    "tax": "การคิดภาษี",
    "source": "มาจาก",
    "reference": "อ้างอิง",
    "staff": "ผู้บันทึก",
    "correction": "แถว 訂正"
  },
  "entry_type": {
    "receive": "受入 · รับเข้า",
    "deliver": "払出 · จ่ายออก"
  },
  "counterparty": {
    "individual": "บุคคล",
    "business": "นิติบุคคล"
  },
  "channel": {
    "face_to_face": "対面 · ต่อหน้า",
    "remote": "非対面 · ไม่ต่อหน้า"
  },
  "tax": {
    "kobutsu_tokurei": "古物商特例",
    "shogaku_tokurei": "少額特例",
    "transitional_70": "経過措置 80/70 %",
    "qualified_invoice": "適格請求書",
    "not_applicable": "ไม่ใช่การซื้อ"
  },
  "source": {
    "buylist": "รับซื้อ",
    "consignment": "ฝากขาย",
    "customer_return": "ลูกค้าคืนของ"
  },
  "filters": {
    "date": "วันที่ (เวลาญี่ปุ่น)",
    "counterparty": "ชื่อคู่ค้า",
    "q": "การ์ด เลข หรือใบรับรอง",
    "q_hint": "เช่น 095/069 หรือ 12345678",
    "big": "¥10,000 ขึ้นไป"
  },
  "incomplete": {
    "banner_one": "มี {{count}} แถวที่ขาด 本人確認 หรือข้อมูลที่ต้องมี",
    "banner_other": "มี {{count}} แถวที่ขาด 本人確認 หรือข้อมูลที่ต้องมี",
    "show": "แสดง",
    "fix": "ผู้ฝากที่ยังไม่ทำ 本人確認",
    "missing": "ขาดอะไร",
    "none": "ทุกแถวครบแล้ว"
  },
  "problems": {
    "identity_check_missing": "ไม่มี 本人確認",
    "counterparty_address_missing": "ไม่มีที่อยู่",
    "counterparty_occupation_missing": "ไม่มีอาชีพ",
    "counterparty_age_missing": "ไม่มีอายุ",
    "confirmation_method_missing": "ไม่มีวิธีตรวจบัตร",
    "item_features_missing": "ไม่มีจุดสังเกต"
  },
  "entry": {
    "title": "แถวใน 古物台帳",
    "load_failed": "โหลดแถวนี้ไม่ได้",
    "date": "วันที่",
    "item": "รายการ",
    "features": "จุดสังเกต",
    "category": "หมวด",
    "quantity": "จำนวน",
    "price": "ราคา",
    "total": "ยอดทั้งรายการ",
    "counterparty": "คู่ค้า",
    "address": "ที่อยู่",
    "occupation": "อาชีพ",
    "age": "อายุ",
    "method": "ตรวจบัตรด้วย",
    "channel": "วิธี",
    "tax": "การคิดภาษี",
    "source": "มาจาก",
    "kept_until": "เก็บถึง",
    "corrected_one": "มี 訂正 {{count}} ครั้ง",
    "corrected_other": "มี 訂正 {{count}} ครั้ง",
    "corrections": "รายการ 訂正"
  },
  "correction": {
    "button": "เพิ่มแถว 訂正",
    "title": "เพิ่มแถว 訂正",
    "intro": "แถวเดิมอยู่เหมือนเดิม ระบบเพิ่มแถวใหม่ที่มีค่าที่ถูกต้องและเหตุผล",
    "field": "ช่องที่ผิด",
    "value": "ค่าที่ถูกต้อง",
    "reason": "เหตุผล",
    "save": "เพิ่ม 訂正",
    "missing": "ใส่ค่าที่ถูกต้องและเหตุผล",
    "done": "เพิ่มแถว 訂正 แล้ว",
    "fields": {
      "itemDescription": "รายการ",
      "itemFeatures": "จุดสังเกต",
      "counterpartyName": "ชื่อ",
      "counterpartyAddress": "ที่อยู่",
      "counterpartyOccupation": "อาชีพ",
      "confirmationMethod": "ตรวจบัตรด้วย"
    }
  },
  "export": {
    "button": "ส่งออก",
    "title": "ส่งออก 古物台帳",
    "intro": "สำหรับตำรวจ (様式15 / 様式16) หรือ Excel (CSV)",
    "format": "แบบไหน",
    "formats": {
      "style15": "様式15 · รับเข้า",
      "style15_hint": "PDF ของที่รับเข้า",
      "style16": "様式16 · จ่ายออก",
      "style16_hint": "PDF ของที่จ่ายออก",
      "csv": "CSV",
      "csv_hint": "ทุกแถว เปิดด้วย Excel"
    },
    "range": "ช่วงเวลา",
    "presets": {
      "last_month": "เดือนที่แล้ว",
      "this_month": "เดือนนี้",
      "custom": "เลือกวันที่"
    },
    "from": "ตั้งแต่",
    "to": "ถึง",
    "bad_range": "วันเริ่มอยู่หลังวันสิ้นสุด",
    "audited": "ทุกการส่งออกถูกบันทึก (ใคร เมื่อไร)",
    "not_checked": "รูปแบบยังไม่ได้ให้ 行政書士 ตรวจ",
    "make_pdf": "ทำ PDF",
    "download_csv": "ดาวน์โหลด CSV",
    "making": "กำลังทำ PDF…",
    "open_one": "เปิด PDF ({{count}} แถว)",
    "open_other": "เปิด PDF ({{count}} แถว)",
    "failed": "ทำ PDF ไม่ได้"
  }
}
